export default __webpack_public_path__ + "archive.ef7781a653719cd9.svg";